import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ISplitUserBookings } from 'app/amendment/bookings/bookings.interfaces'
import { toParamsObj } from 'app/shared/utils'
import { StatelessHttpService } from 'app/shared/stateless-http.service'

@Injectable()
export class BookingsService {

    constructor(
        private statelessHttpService: StatelessHttpService) {
    }

    public getBookings(userId: string, locale: string): Observable<ISplitUserBookings> {
        let params = {
            'userId': userId,
            'locale': locale
        }
        return this.statelessHttpService.get<ISplitUserBookings>(true, 'reservations', { params: toParamsObj(params) })
    }
}
